import { render } from "./PaymentSuccessful.vue?vue&type=template&id=1a88823e&scoped=true"
import script from "./PaymentSuccessful.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessful.vue?vue&type=script&lang=js"

import "./PaymentSuccessful.vue?vue&type=style&index=0&id=1a88823e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a88823e"]])

export default __exports__